export function elapsedSeconds(from: Date, now: number) {
  return Math.max(0, Math.floor((now - from.getTime()) / 1000));
}

// Таймер: минуты:секунды, часы — только когда набежали.
export function formatTimer(seconds: number) {
  const pad = (value: number) => String(value).padStart(2, "0");
  const hours = Math.floor(seconds / 3600);
  const rest = `${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
  return hours ? `${hours}:${rest}` : rest;
}

// Длительность словами и без секунд: на неё смотрят мельком.
export function formatDuration(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  if (!hours) return `${minutes} мин`;
  return `${hours} ч ${minutes % 60} мин`;
}

export function formatTime(date: Date) {
  return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

// Время документа: сегодня — только часы, иначе с датой.
export function formatMoment(date: Date) {
  const today = new Date().toDateString() === date.toDateString();
  return today
    ? formatTime(date)
    : date.toLocaleString("ru-RU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

const money = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });

export function formatMoney(amount: number | null | undefined) {
  // Неразрывный пробел перед ₽ — знак рубля не уезжает на следующую строку.
  return amount === null || amount === undefined ? "" : `${money.format(amount)}\u00a0₽`;
}

export function plural(count: number, one: string, few: string, many: string) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

const integer = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });

export function formatBonuses(bonuses: number) {
  return `${integer.format(bonuses)}\u00a0${plural(bonuses, "бонус", "бонуса", "бонусов")}`;
}
